module.exports = __webpack_public_path__ + "static/media/sunrisers.305fadc1.png";